import React from 'react';
import { Grid, makeStyles, Theme, Tooltip, Typography } from '@material-ui/core';
import { dividerColor, typographyColorKeys } from 'src/data/colors';

interface DataLabelProps {
  divider?: boolean;
  label: string;
  value?: string;
  noMargin?: boolean;
  truncate?: boolean;
  withTooltip?: boolean;
  labelExtraMargin?: boolean;
  valueColor?: keyof typeof typographyColorKeys;
}

interface StylesProps {
  divider: boolean;
  noMargin: boolean;
  truncate: boolean;
  labelExtraMargin: boolean;
  valueColor: keyof typeof typographyColorKeys;
}

const useStyles = makeStyles<Theme, StylesProps>((theme: Theme) => ({
  item: {
    padding: '0 !important',
    textOverflow: ({ truncate }) => (truncate ? 'ellipsis' : 'clip'),
    whiteSpace: ({ truncate }) => (truncate ? 'nowrap' : 'normal'),
    width: '100%',
  },
  label: {
    fontSize: 12,
    fontWeight: 500,
    textTransform: 'uppercase',
    fontFamily: 'DM Mono',
    marginBottom: ({ labelExtraMargin, noMargin }) => (labelExtraMargin ? 16 : noMargin ? 0 : 8), //ouch
  },
  value: {
    fontSize: 16,
    textOverflow: ({ truncate }) => (truncate ? 'ellipsis' : 'clip'),
    whiteSpace: ({ truncate }) => (truncate ? 'nowrap' : 'normal'),
    overflow: ({ truncate }) => (truncate ? 'hidden' : 'visible'),
    width: '100%',
    fontWeight: 500,
    color: ({ valueColor }) => valueColor,
  },
  container: {
    marginBottom: ({ noMargin }) => (noMargin ? 0 : 16),
    borderBottom: ({ divider }) => (divider ? `1px solid ${dividerColor}` : 'none'),
    paddingBottom: ({ divider }) => (divider ? 16 : 0),
  },
}));

const DataLabel: React.FC<DataLabelProps> = (props) => {
  const {
    divider = false,
    label,
    value,
    noMargin = false,
    truncate = false,
    withTooltip = false,
    labelExtraMargin = false,
    valueColor = 'black',
  } = props;

  const classes = useStyles({ divider, noMargin, truncate, labelExtraMargin, valueColor });

  return (
    <Grid container direction="column" className={classes.container}>
      <Grid item className={classes.item}>
        <Typography className={classes.label}>{label}</Typography>
      </Grid>
      {value && (
        <Grid item className={classes.item}>
          {withTooltip ? (
            <Tooltip title={value} placement="top">
              <Typography className={classes.value}>{value}</Typography>
            </Tooltip>
          ) : (
            <Typography className={classes.value}>{value}</Typography>
          )}
        </Grid>
      )}
    </Grid>
  );
};

export default DataLabel;
